import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { mistakes } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Mistakes() {
  return <section className="bg-cream" data-id="element-150" data-mp="v67l99hsrka5">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-151" data-mp="v78ud8f95wp8">
        <SectionHeading eyebrow="El porqué detrás de cada cambio" title={<>
              Pequeños errores pueden cambiar por completo{' '}
              <span className="text-clay" data-id="element-153" data-mp="3gmb05dg4hce">cómo se siente un espacio</span>
            </>} subtitle="Cuando entendés el porqué de cada decisión, empezás a transformar tu hogar con intención." data-id="element-152" data-mp="105tvrb68qmf9" />

        <ul className="mx-auto mt-12 grid max-w-4xl gap-5 sm:mt-16 sm:gap-6" data-id="element-154" data-mp="cey3ye1sbr80">
          {mistakes.map(item => <li key={item.problem} className="grid gap-3 sm:grid-cols-2 sm:gap-5" data-id="element-155" data-mp="hgdswh732hvo">
              <div className="flex h-full gap-3.5 rounded-2xl bg-clay-tint p-5 sm:p-6" data-id="element-156" data-mp="1nttmib3jyctu">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/70" aria-hidden="true" data-id="element-157" data-mp="1st6hjj4kuq7i">
                  <XIcon className="h-4 w-4 text-clay-dark" strokeWidth={2.5} data-id="element-158" data-mp="ypifjj4dmiwu" />
                </span>
                <div data-id="element-159" data-mp="uphomz03cf8w">
                  <h3 className="font-display text-[17px] font-semibold leading-snug text-ink sm:text-[18.5px]" data-id="element-160" data-mp="ppn0323sg1r0">
                    {item.problem}
                  </h3>
                  <p className="mt-2 text-[13.5px] leading-[1.6] text-ink-soft sm:text-[14px]" data-id="element-161" data-mp="kqaf6mwh94r2">
                    {item.problemDetail}
                  </p>
                </div>
              </div>

              <div className="flex h-full gap-3.5 rounded-2xl bg-sage-tint p-5 sm:p-6" data-id="element-162" data-mp="azftbjn58765">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/70" aria-hidden="true" data-id="element-163" data-mp="6zne4o38v2rt">
                  <CheckIcon className="h-4 w-4 text-sage-deep" strokeWidth={2.5} data-id="element-164" data-mp="3t6c8ktmxlljb" />
                </span>
                <div data-id="element-165" data-mp="3o7969gyc5tf1">
                  <h3 className="font-display text-[17px] font-semibold leading-snug text-ink sm:text-[18.5px]" data-id="element-166" data-mp="3o6za1bmp6q0w">
                    {item.solution}
                  </h3>
                  <p className="mt-2 text-[13.5px] leading-[1.6] text-ink-soft sm:text-[14px]" data-id="element-167" data-mp="3jiq6pr6bycav">
                    {item.solutionDetail}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}